import { Plus } from "lucide-react";
import React from "react";

import { IgIconButton } from "@intelligems/ig-theme";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { useDispatch } from "@src/store";
import { ExperienceBuilderAction } from "@src/store/slices/experienceBuilder";

interface CopyButtonProps {
  mod: EmbeddedMod;
  targetVariationId: string;
}

export const CopyButton = ({ mod, targetVariationId }: CopyButtonProps) => {
  const dispatch = useDispatch();

  return (
    <IgIconButton
      aria-label="copy modification"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        void dispatch(
          ExperienceBuilderAction.copyMod({
            mod,
            targetVariationId,
          })
        );
      }}
    >
      <Plus size={16} />
    </IgIconButton>
  );
};
